var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterFenceMRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 44,
    viewBox: "0 0 26 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81079 5.27228L17.0309 0.248901L25.2509 14.4057V38.6093L17.0309 43.6326L8.81079 5.27228Z",
    fill: "#A06A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.590576 33.5859V9.38238L9.26733 5.27234L17.0307 19.4291V43.6327L0.590576 33.5859Z",
    fill: "#CB8E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterFenceMRDefault);
export default __webpack_public_path__ + "static/media/winter_fence_m_r_default.e9ea24b2c5cb24e0a05b12455a51513d.svg";
export { ForwardRef as ReactComponent };